import React from 'react'
import { mapKeys, pick } from 'lodash'
import { connect } from 'components'

const keys = {
  initial: 'subscriptionId priceId amount vatAmount amountToDisplay vatAmountToDisplay discount subscriptionEnglishName offerId md5Signature'.split(
    ' '
  ),
  recurring: 'initialAmount normalPriceId normalAmount normalAmountDisplay vatNormalAmount intervalMultiplier intervalUnit startIntervalMultiplier startIntervalUnit startDate'.split(
    ' '
  ),
}
const hiddenFields = (data, prefix = '') =>
  Object.entries(data).map(([key, value]) => {
    const name = prefix + key
    return <input type="hidden" key={name} name={name} value={value === null ? '' : value} />
  })

const UpgradeForm = ({ memberships, membership, profile, selected, siteId, lc, query, vip, children, formProps }) => (
  <form method="post" {...formProps} className="pe-form">
    <input type="hidden" name="shoppingCartId" value={selected.chosen && selected.gold.id} />
    {vip && <input type="hidden" name="shoppingCartId" value={memberships.vip.id} />}
    {memberships.gold.concat(vip ? memberships.vip : []).map(data =>
      hiddenFields(
        {
          ...mapKeys(pick(data, keys.initial), (value, key) => key.replace('subscriptionEnglishName', 'description')),
          ...mapKeys(pick(data, keys.recurring), (value, key) => `recurringDetails.${key}`),
          'recurringDetails.futurePayType': 'regular',
        },
        `subscriptionDetails[${data.subscriptionId}].`
      )
    )}
    {hiddenFields({
      ...pick(membership, 'installationId currencyIsoCode currencyIsoCodeToDisplay taxId vatPercentage'.split(' ')),
      M_userId: profile.id,
      M_transactionType: 'ADD',
      M_paidByUserId: '',
      M_siteId: siteId,
      M_campaignId: query.campaignId || 0,
      M_mailId: query.mailId || 0,
      M_itemId: query.itemId || 0,
      M_policyId: query.policyId || 1,
      mobile: false,
      returnUrl: `${location.origin}/payment/success/`,
      cancelUrl: `${location.origin}/payment/upgrade/`,
      lc,
      eC: true,
    })}
    {children}
  </form>
)

const mapStateToProps = ({ myProfile, siteConfig, account, upgrade, router }, { memberships }) => ({
  profile: myProfile,
  siteId: siteConfig.siteId,
  lc: account.lc,
  vip: !!upgrade.selected.vip,
  membership: upgrade.selected.vip ? memberships.vip : memberships.gold[0],
  query: router.location.query,
})

export default connect(mapStateToProps)(UpgradeForm)
